import { useDownloadMutation } from "@/services";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import { bool, exact, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

export const DownloadWithAuth = ({
  attachment: { url, name } = {},
  disabled,
}) => {
  const intl = useIntl();

  const [isLoading, setIsLoading] = useState(false);

  const [download] = useDownloadMutation();

  const handleDownloadClick = () => {
    if (!url) return;

    setIsLoading(true);
    download(url)
      .unwrap()
      .then(({ data: { data } }) => {
        if (!data) return;

        const win = window.open(data, "_blank");
        win.focus();
      })
      .catch(() => {
        toast.error(intl.formatMessage({ id: "general.genericErrorMessage" }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Button
      data-test-id="download-with-auth-download"
      icon={<FontAwesomeIcon icon={faDownload} />}
      onClick={handleDownloadClick}
      loading={isLoading}
      style={{ overflow: "hidden", maxWidth: "100%" }}
      disabled={disabled}
    >
      {name || intl.formatMessage({ id: "general.download" })}
    </Button>
  );
};

DownloadWithAuth.propTypes = {
  attachment: exact({
    url: string,
    name: string,
  }),
  disabled: bool,
};
